import {Component, OnInit, Output, EventEmitter, AfterViewInit, AfterViewChecked} from '@angular/core';
import {ApiService} from '../../api.service';
import {Store} from '@ngrx/store';
import {GlobalService} from '../../global.service';
import {Router} from '@angular/router';
import {MainCampaignActions} from '../../main-campaign/main-campaign.actions';

@Component({
    selector: 'app-plans',
    templateUrl: './plans.component.html',
    styleUrls: ['./plans.component.scss']
})
export class PlansComponent implements OnInit, AfterViewInit {
    constructor(private apiService: ApiService,
                private store: Store<any>,
                private mainCampaignActions: MainCampaignActions,
                private globalService: GlobalService, private router: Router) {
    }

    //khoi tao
    data_plans: any = [];
    itemBroadband: any;
    @Output() broadband = new EventEmitter();

    ngOnInit() {

        /**loading */
        $('.loading_check').css({
            'opacity': '0', 'z-index': '-1'
        });

        /**get devices */
        $('title').html(this.globalService.getSession('viewPlan').attributes.campaign_name);

        /**get plans */
        this.data_plans = this.globalService.getSession('viewPlan').attributes.plans;
        this.data_plans.sort(function (a, b) {
            return a.rebate_price - b.rebate_price;
        });

        /**check OS and style for view-plans_pc */
        var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

        if (isSafari) {
            // console.log('You are using Safari on iOS!');
            $('.view-plans_pc').css('flex-wrap', 'nowrap');

        } else {
            // console.log("other.");
        }

        /** other style when data_plans.length < 4 */
        if (this.data_plans.length < 4) {
            $('.view-plans_pc').addClass('justify-content-md-center');
        } else {
            $('.view-plans_pc').removeClass('justify-content-md-center');
            if (isSafari) {
                // console.log('You are using Safari on iOS!');
                $('.view-plans_pc').css('display', 'block');

            } else {
                // console.log("other.");
            }
        }

        /**window load slider plans */
        $(window).on('load', function () {
            //layout mobile
            (<any>$)('.view-plans-slider_mobile').on('init , setPosition', function () {

                if ($(window).outerWidth() <= 768) {
                    $('.view-plans_pc').hide();
                    $('.view-plans-slider_mobile .slick-list').css('padding', '0px 15px');
                    $('.view-plans-slider_mobile').show();
                } else {
                    $('.view-plans-slider_mobile').hide();
                    $('.view-plans_pc').show();
                }
            });

            //slider mobile
            // (<any>$)('.view-plans-slider_mobile')
            (<any>$)('.view-plans-slider_mobile').not('.slick-initialized').slick({
                slidesToShow: 1,
                dots: true,
                infinite: false,
                centerMode: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 1500,
            });
        });


    }

    ngAfterViewInit(): void {
        //layout mobile
        (<any>$)('.view-plans-slider_mobile').on('init , setPosition', function () {

            if ($(window).outerWidth() <= 768) {
                $('.view-plans_pc').hide();
                $('.view-plans-slider_mobile .slick-list').css('padding', '0px 15px');
                $('.view-plans-slider_mobile').show();
            } else {
                $('.view-plans-slider_mobile').hide();
                $('.view-plans_pc').show();
            }
        });

        //slider mobile
        // (<any>$)('.view-plans-slider_mobile')
        (<any>$)('.view-plans-slider_mobile').not('.slick-initialized').slick({
            slidesToShow: 1,
            dots: true,
            infinite: false,
            centerMode: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 1500,
        });
    }


    onChoosePlan(item) {

        $('.loading_check').css({
            'opacity': '1', 'z-index': '999'
        });

        /**save planId to session */
        let newValueSession = Object.assign({}, this.globalService.getSession('mainApplication'), {
            planId: item.id
        });

        this.globalService.setSession('mainApplication', newValueSession);
        this.globalService.setSession('digi_type', 'plans_type');
        this.globalService.setSession('digi_plan_category', item.plan_category);


        /** call broadband from plan */
        let dataRequestBroadbrand = {
            campaign_Id: parseInt(this.globalService.getSession('id_campaign')),
            plan_Id: item.id
        };
        this.apiService.getBroadbrand(dataRequestBroadbrand).subscribe(res => {
            this.globalService.setSession('broad_plan', res.data.broad_plan.original.data.collection);
        });

        /**redirect to main-campaign */
        this.router.navigateByUrl('/main-campaign');

    }


}
